const LeanOnMe = [
	'[Verse 1]',
	'Sometimes in our lives',
	'We all have pain',
	'We all have sorrow',
	'But if we are wise',
	"We know that there's always tomorrow",
	'',
	'[Chorus]',
	"Lean on me, when you're not strong",
	"And I'll be your friend",
	"I'll help you carry on",
	"For it won't be long",
	"'Til I'm gonna need",
	'Somebody to lean on',
	'',
	'[Verse 2]',
	'Please swallow your pride',
	'If I have things',
	'You need to borrow',
	'For no one can fill',
	'Those of your needs',
	"That you won't let show",
	'',
	'[Bridge]',
	'So just call on me brother, when you need a hand',
	'We all need somebody to lean on',
	"I just might have a problem that you'd understand",
	'We all need somebody to lean on',
	'',
	'[Chorus]',
	"Lean on me, when you're not strong",
	"And I'll be your friend",
	"I'll help you carry on",
	"For it won't be long",
	"'Til I'm gonna need",
	'Somebody to lean on',
	'',
	'[Bridge]',
	'So just call on me brother, when you need a hand',
	'We all need somebody to lean on',
	"I just might have a problem that you'd understand",
	'We all need somebody to lean on',
	'',
	'[Verse 3]',
	'If there is a load',
	'you have to bear',
	"That you can't carry",
	"I'm right up the road",
	"I'll share your load",
	'If you just call me (call me)',
];

export default LeanOnMe;
